import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Link from 'next/link';
import CheckoutDialog from '../Dialog/DialogCheckout';
import PlacebidDialog from '../Dialog/DialogPlacebid';
import OwnerComponent from './OwnerComponent';
import { bucketlink1 } from '../../config/fire-conf';

export default function OwnserTab(props) {
  const userDataRedux = useSelector((state) => state.authReducer.userData);

  const [confirmationCheckoutDialogState, setconfirmationCheckoutDialogState] =
    useState(false);
  const [confirmationPlacebidDialogState, setconfirmationPlacebidDialogState] =
    useState(false);
  const [selectedNftId, setselectedNftId] = useState('');

  return (
    <>
      <div className="nft__tab_pane nft__tab__pane--scroll" role="tabpanel">
        <div className="nft__tab_content">
          {(() => {
            if (props.nftData && !props.nftData.multiView) {
              return (
                <div
                  className={'asset__author'}
                  style={{
                    height: 55,
                  }}
                >
                  <div>
                    <div className={'asset__author asset__author--verified '}>
                      <img
                        style={{ minWidth: 44, minHeight: 44 }}
                        src={
                          props?.nftData?.userId &&
                          bucketlink1 +
                            'profile_images%2F' +
                            props.nftData.userId +
                            '_250x250?alt=media'
                        }
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = '/img/avatars/avatar.jpg';
                        }}
                        alt="owner"
                      />
                    </div>
                  </div>
                  <Link
                    prefetch={false}
                    href={`/collector/${
                      props.nftData ? props.nftData.userId : ''
                    }`}
                  >
                    {props.checkoutUserName && <a>@{props.checkoutUserName}</a>}
                  </Link>
                </div>
              );
            } else if (
              props.nftData &&
              props.nftData.multiView &&
              props.nftData.multipleNftDetails
            ) {
              let allolength = Object.values(
                props.nftData.multipleNftDetails,
              ).sort(function (x, y) {
                return x.activeInMarketPlace === y.activeInMarketPlace
                  ? 0
                  : x.activeInMarketPlace
                  ? -1
                  : 1;
              }).length;
              return Object.values(props.nftData.multipleNftDetails)
                .sort((x, y) => (x.index > y.index ? 1 : -1))
                .map((ele, index) => {
                  return (
                    <OwnerComponent
                      ele={ele}
                      index={index}
                      alllength={allolength}
                      nftData={props.nftData}
                      setselectedNftId={setselectedNftId}
                      setconfirmationPlacebidDialogState={
                        setconfirmationPlacebidDialogState
                      }
                      setconfirmationCheckoutDialogState={
                        setconfirmationCheckoutDialogState
                      }
                      setcheckoutUserName={props.setcheckoutUserName}
                    />
                  );
                });
            }
          })()}

          {/* {loading && (
                    <div className="flex justify-center	w-full my-6 ">
                        <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto text-3xl"></i>
                    </div>
                )} */}
        </div>
      </div>

      <CheckoutDialog
        ownerName={props.checkoutUserName}
        dialogState={confirmationCheckoutDialogState}
        setdialogState={setconfirmationCheckoutDialogState}
        nftData={
          props.nftData && props.nftData.isMultiple
            ? {
                ...props.nftData,
                ...props.nftData.multipleNftDetails[selectedNftId],
              }
            : {
                ...props.nftData,
              }
        }
      />
      <PlacebidDialog
        open={confirmationPlacebidDialogState}
        setdialogState={setconfirmationPlacebidDialogState}
        nftData={
          props.nftData && props.nftData.isMultiple
            ? {
                ...props.nftData,
                ...props.nftData.multipleNftDetails[selectedNftId],
              }
            : {
                ...props.nftData,
              }
        }
        setnftData={props.setnftData}
        userDataRedux={userDataRedux}
      />
    </>
  );
}
